import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState } from 'react';
import { IconButton, StandardButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';
import { Modal, ModalTypes } from '@eika/modal';
const corporateTexts = {
  header: 'Land virksomheten er skattemessig bosatt i',
  numberFormatting: 'Oppgi identifikasjon-/skatteidentifikasjonsnummer for det landet virksomheten er skattemessig hjemmehørende i. Deler av nummeret kan også inneholde bokstaver.',
  mainText: 'Virksomheten kan være skattemessig bosatt i flere land. Vanligvis er skattemessig bosted i det landet virksomheten har sitt faste bosted eller der den oppholder seg fast, men hvert land har imidlertid sin egen måte å definer skattemessig bosted på. For mer informasjon, velg aktuelt land i følgende link:'
};
const personTexts = {
  header: 'Land du er skattemessig bosatt i',
  numberFormatting: 'Oppgi identifikasjon-/skatteidentifikasjonsnummer du bruker i det landet du er skattemessig bosatt i. Deler av nummeret kan også inneholde bokstaver.',
  mainText: 'Du kan være skattemessig bosatt i flere land. Vanligvis er skattemessig bosted i det landet du har ditt faste bosted eller der du oppholder deg fast, men hvert land har imidlertid sin egen måte å definer skattemessig bosted på. For mer informasjon, velg aktuelt land i følgende link:'
};
const NonUsTaxRelationsHelpModal = _ref => {
  let {
    className,
    isCorporate
  } = _ref;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => setIsModalOpen(false);
  const showModal = e => {
    e.preventDefault();
    setIsModalOpen(true);
  };
  const texts = isCorporate ? corporateTexts : personTexts;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    className: className,
    onClick: showModal,
    icon: IconTypes.INFO_20,
    id: "help-icon-overall-tax-relations",
    screenReaderText: "Hjelpetekst"
  }), /*#__PURE__*/React.createElement(Modal, {
    onClose: closeModal,
    show: isModalOpen,
    id: "helpermodal__modal",
    type: ModalTypes.STANDARD,
    appNamespace: "kyc-declaration.app"
  }, /*#__PURE__*/React.createElement("div", {
    role: "tooltip",
    id: "helpermodal"
  }, /*#__PURE__*/React.createElement("p", null, texts.header), /*#__PURE__*/React.createElement("p", null, texts.mainText), /*#__PURE__*/React.createElement(Link, {
    href: "http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-residency",
    target: "_blank",
    rel: "noreferrer"
  }, "http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-residency"), /*#__PURE__*/React.createElement("p", null, texts.numberFormatting), "For informasjon knyttet til format, velg aktuelt land i f\xF8lgende link:", /*#__PURE__*/React.createElement(Link, {
    href: "http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers",
    target: "_blank",
    rel: "noreferrer"
  }, "http://www.oecd.org/tax/automatic-exchange/crs-implementation-and-assistance/tax-identification-numbers"), /*#__PURE__*/React.createElement(StandardButton, {
    className: "help-modal-button",
    onClick: closeModal
  }, "Lukk"))));
};
export default NonUsTaxRelationsHelpModal;